import { createApi } from "@reduxjs/toolkit/query/react";
import { gql } from "graphql-request";
import customBaseQuery from "../../../utils/customBaseQuery";

let defaultQuery = `{
  timestamp
  error
  version
  data {
    parentId
    parentType
    courseDetails {
      id
      title
      shortdescription
      referenceMaterialList {
        id
        title
        shortDescription
        createdby
        artifactType
        weblink
        artifactText
        artifactId
        downloadable
      }
      moduleList {
        id
        title
        shortdescription
        referenceMaterialList {
          id
          title
          shortDescription
          artifactType
          weblink
          artifactText
          artifactId
        }
        chapterList {
          id
          title
          shortdescription
          referenceMaterialList {
            id
            title
            shortDescription
            artifactType
            weblink
            artifactText
            artifactId
          }
        }
      }
    }
    learningpathDetails {
      id
      title
      shortdescription
      referenceMaterialList {
        id
        title
        createdby
        shortDescription
        artifactType
        weblink
        artifactText
        artifactId
        downloadable
      }
      sectionList {
        id
        title
        shortdescription
        referenceMaterialList {
          id
          title
          shortDescription
          artifactType
          weblink
          artifactText
          artifactId
          downloadable
          parentType
          parentId
        }
      }
    }
    eventDetails {
      id
      title
      shortdescription
      startdate
      enddate
      referenceMaterialList {
        id
        title
        createdby
        shortDescription
        artifactType
        weblink
        artifactText
        artifactId
        downloadable
        parentType
        parentId
      }
      sessionList {
        id
        title
        shortdescription
        startdate
        enddate
        referenceMaterialList {
          id
          title
          shortDescription
          artifactType
          weblink
          artifactText
          artifactId
          downloadable
          parentType
          parentId
        }
        agendaList {
          id
          startdate
          enddate
          referenceMaterialList {
            id
            title
            shortDescription
            artifactType
            weblink
            artifactText
            artifactId
            downloadable
            parentType
            parentId
          }
        }
      }
    }
  }
}`;

let cafeQuery = `{
  timestamp
  error
  version
  data {
    eventDetails {
      id
      title
      shortdescription
      startdate
      enddate
      referenceMaterialList {
        id
        title
        createdby
        shortDescription
        artifactType
        weblink
        artifactText
        artifactId
        downloadable
        parentType
        parentId
        transcript
        videoInterval
        catchPhrase
        skills
        conciseAiSummary
        comprehensiveAiSummary
        searchTags {
        defaultTag
        }
      }
    }
  }
}`;

export const ReferenceMaterialApiSlice = createApi({
  reducerPath: "referenceMaterialApi",
  baseQuery: customBaseQuery,
  refetchOnFocus: true,
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    createReferenceMaterial: builder.mutation({
      query: ({ body, parentType, parentId }: any) => ({
        url: `/reference-material/${parentType}/${parentId}`,
        method: "POST",
        body: body
      }),
      extraOptions: { service: "Widget" }
    }),
    deleteReferenceMaterial: builder.mutation({
      query: ({ body, parentType, parentId }: any) => ({
        url: `/reference-material/${parentType}/${parentId}`,
        method: "DELETE",
        body: body
      }),
      extraOptions: { service: "Widget" }
    }),
    fetchAllReferenceMaterialForParent: builder.query({
      query: ({ parentType, parentId, query }: any) => ({
        url: "/graphql",
        body: gql`
          query{
              fetchAllReferenceMaterialForParent(parentType:"${parentType}", parentId:"${parentId}") 
                  ${query && query == "cafe" ? cafeQuery : defaultQuery}
            }`
      }),
      extraOptions: { service: "Widget" }
    })
  })
});

export const {
  useCreateReferenceMaterialMutation,
  useDeleteReferenceMaterialMutation,
  useFetchAllReferenceMaterialForParentQuery,
  useLazyFetchAllReferenceMaterialForParentQuery
} = ReferenceMaterialApiSlice;
